var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4464 2.75346C12.4464 3.943 11.4821 4.90731 10.2925 4.90731C9.10298 4.90731 8.13867 3.943 8.13867 2.75346C8.13867 1.56392 9.10298 0.599609 10.2925 0.599609C11.4821 0.599609 12.4464 1.56392 12.4464 2.75346Z",
    stroke: "#39464E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7549 3.23438C17.6809 3.2345 18.4316 3.98507 18.4316 4.91113C18.4315 5.8371 17.6808 6.58777 16.7549 6.58789C15.8288 6.58789 15.0782 5.83717 15.0781 4.91113C15.0781 3.98499 15.8287 3.23438 16.7549 3.23438Z",
    stroke: "#39464E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92676 3.23438C4.8528 3.2345 5.60352 3.98507 5.60352 4.91113C5.60339 5.8371 4.85272 6.58777 3.92676 6.58789C3.00069 6.58789 2.25012 5.83717 2.25 4.91113C2.25 3.98499 3.00062 3.23438 3.92676 3.23438Z",
    stroke: "#39464E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9082 11.3694C4.9082 9.58514 6.35467 8.13867 8.13898 8.13867H12.4467C14.231 8.13867 15.6775 9.58514 15.6775 11.3694V13.5233C15.6775 14.1181 15.1953 14.6002 14.6005 14.6002H5.98513C5.39036 14.6002 4.9082 14.1181 4.9082 13.5233V11.3694Z",
    stroke: "#39464E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36885 10.2949H1.67653C1.08177 10.2949 0.599609 10.7771 0.599609 11.3718V13.5257C0.599609 14.1205 1.08177 14.6026 1.67653 14.6026H10.2919",
    stroke: "#39464E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2141 10.2949H18.9064C19.5012 10.2949 19.9833 10.7771 19.9833 11.3718V13.5257C19.9833 14.1205 19.5012 14.6026 18.9064 14.6026H10.291",
    stroke: "#39464E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/Students.88ee326260e274fea897bd0f160f059e.svg";
export { ForwardRef as ReactComponent };